




import { Component, Emit, Vue } from 'vue-property-decorator'

@Component
export default class AddToCartButtonComponent extends Vue {
  @Emit()
  public addToCart(): void {
    return
  }
}
